import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useHistory } from "react-router-dom";
import { removeLocalData } from "../../helpers/storage-helper";
import { authActions } from "../../store/auth";
import Loader from "../UI/loader";
import {
  AiFillCaretDown,
  AiOutlineHome,
  AiOutlineSetting,
  AiOutlineUser,
} from "react-icons/ai";
import { FiUsers, FiBarChart2 } from "react-icons/fi";

import { endPoints } from "../../config/end-points";
import "./header.css";
import { ImProfile } from "react-icons/im";
import { HiOutlineLogout } from "react-icons/hi";
import { BiSupport } from "react-icons/bi";
import { BsCameraVideo, BsKey, BsInbox, BsTag } from "react-icons/bs";
import useOnclickOutside from "react-cool-onclickoutside";

const Header = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loader = useSelector((state) => state.auth.loader);

  const onLogout = () => {
    removeLocalData("sitebuilder_user");
    dispatch(authActions.logout());
    dispatch(authActions.resetState());
    history.push("/login");
  };

  const [showActionPopup, setShowActionPopup] = useState(false);

  const refsubMenu = useOnclickOutside(() => {
    setShowActionPopup(false);
  });

  const user_roles = useSelector((state) => state.auth.roles);
  const first_name = useSelector((state) => state.auth.first_name);
  const userId = useSelector((state) => state.auth.id);
  const access = useSelector((state) => state.auth.access) || '';
  const whitelabel = useSelector((state) => state.auth.whitelabel);

  const hasWhitelabelAccess = ['6','61','62','9'].some(c => access.includes(c)) || user_roles?.role_id === 3;
  const isSuperAdmin = userId === 1 || access.split(',').map(a => a.trim()).includes('5');

  // Apply whitelabel title and favicon
  useEffect(() => {
    if (whitelabel?.site_title) {
      document.title = whitelabel.site_title;
    }
    if (whitelabel?.favicon) {
      const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
      link.rel = 'icon';
      link.href = whitelabel.favicon;
      document.head.appendChild(link);
    }
  }, [whitelabel]);

  return (
    <>
      <header id="header">
        <nav className="navbar navbar-expand-md">
          <div className="container">
            <NavLink className="navbar-brand" to="/">
              <img
                src={endPoints.logo}
                className="img-fluid"
                alt="img"
              />
            </NavLink>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="fa fa-bars"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarCollapse">
              <ul className="navbar-nav m-auto">
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    exact
                    aria-current="page"
                    to="/dashboard"
                  >
                    <i><AiOutlineHome size={16} /></i>
                    <span>Dashboard</span>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    exact
                    aria-current="page"
                    to="/settings"
                  >
                    <i><AiOutlineSetting size={16} /></i>
                    <span>Settings</span>
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    exact
                    aria-current="page"
                    to="/submissions"
                  >
                    <i><BsInbox size={16} /></i>
                    <span>Submissions</span>
                  </NavLink>
                </li>

                {(user_roles.role_id === 3 || user_roles.role_id === 2 || hasWhitelabelAccess) && (
                  <li className="nav-item">
                    <NavLink
                      className="nav-link"
                      to="/users"
                      aria-disabled="true"
                    >
                      <i><FiUsers size={16} /></i>
                      <span>Users</span>
                    </NavLink>
                  </li>
                )}

                {hasWhitelabelAccess && (
                  <li className="nav-item">
                    <NavLink
                      className="nav-link"
                      exact
                      to="/whitelabel"
                    >
                      <i><BsTag size={16} /></i>
                      <span>Whitelabel</span>
                    </NavLink>
                  </li>
                )}

                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    exact
                    to="/tutorials"
                  >
                    <i><BsCameraVideo size={16} /></i>
                    <span>Tutorials</span>
                  </NavLink>
                </li>

                {isSuperAdmin && (
                  <li className="nav-item">
                    <NavLink
                      className="nav-link"
                      exact
                      to="/admin"
                    >
                      <i><FiBarChart2 size={16} /></i>
                      <span>Admin</span>
                    </NavLink>
                  </li>
                )}
              </ul>

              <div className="last_t_r ms-auto">
                <a
                  href="#0"
                  role="button"
                  aria-expanded={showActionPopup}
                  onClick={(e) => {
                    e.preventDefault();
                    setShowActionPopup(!showActionPopup);
                  }}
                >
                  <AiOutlineUser size={15} />
                  <span>{first_name}</span>
                  <AiFillCaretDown size={10} />
                </a>
                {showActionPopup && (
                  <div
                    className="profile_popup show"
                    ref={refsubMenu}
                  >
                    <ul>
                      <li>
                        <NavLink to="/profile" onClick={() => setShowActionPopup(false)}>
                          <ImProfile size={15} />
                          <span>Profile</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/support" onClick={() => setShowActionPopup(false)}>
                          <BiSupport size={15} />
                          <span>Support</span>
                        </NavLink>
                      </li>
                      {user_roles.role_id === 3 && (
                        <li>
                          <NavLink to="/api-keys" onClick={() => setShowActionPopup(false)}>
                            <BsKey size={15} />
                            <span>API Keys</span>
                          </NavLink>
                        </li>
                      )}
                      <li>
                        <a href="#0" onClick={onLogout}>
                          <HiOutlineLogout size={15} />
                          <span>Logout</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </nav>
      </header>
      {loader && <Loader />}
    </>
  );
};

export default Header;
